// Wraps matches in text nodes only, so tags, attributes and entities are never split.
function wrapHighlightMatches(node, regex) {
  Array.from(node.childNodes).forEach(function (child) {
    if (child.nodeType !== Node.TEXT_NODE) {
      wrapHighlightMatches(child, regex);
      return;
    }
    const parts = child.textContent.split(regex);
    if (parts.length === 1) {
      return;
    }
    const doc = child.ownerDocument;
    const fragment = doc.createDocumentFragment();
    parts.forEach(function (part, index) {
      if (index % 2 === 1) {
        const span = doc.createElement('span');
        span.className = 'yellow-highlighted';
        span.textContent = part;
        fragment.appendChild(span);
      } else if (part) {
        fragment.appendChild(doc.createTextNode(part));
      }
    });
    child.replaceWith(fragment);
  });
}

// Returns untrusted HTML for ng-bind-html, which sanitizes it. Pass format 'text' for plain-text values.
app.filter('highlightYellow', function() {
  return function(text, search, format) {
    const body = new DOMParser().parseFromString('', 'text/html').body;
    if (format === 'text') {
      body.textContent = text ?? '';
    } else {
      body.innerHTML = text ?? '';
    }
    if (search) {
      const escapedSearch = String(search).replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
      wrapHighlightMatches(body, new RegExp('(' + escapedSearch + ')', 'i'));
    }
    return body.innerHTML;
  };
});
